import cookie from 'cookie';
import browser from '@openclassrooms/utils/browser';

export default function getCookies() {
  return cookie.parse(browser.document?.cookie ?? '');
}
